/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompassDeviceSource } from './CompassDeviceSource';
import {
    CompassDeviceSourceFromJSON,
    CompassDeviceSourceFromJSONTyped,
    CompassDeviceSourceToJSON,
    CompassDeviceSourceToJSONTyped,
} from './CompassDeviceSource';

/**
 * 
 * @export
 * @interface MacLookupOnAzure
 */
export interface MacLookupOnAzure {
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    pk: string;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    mac_address: string;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    serial_number: string;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof MacLookupOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {CompassDeviceSource}
     * @memberof MacLookupOnAzure
     */
    source: CompassDeviceSource;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    source_ref?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    recorded_at: string;
    /**
     * 
     * @type {string}
     * @memberof MacLookupOnAzure
     */
    recorded_by: string;
}



/**
 * Check if a given object implements the MacLookupOnAzure interface.
 */
export function instanceOfMacLookupOnAzure(value: object): value is MacLookupOnAzure {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('pk' in value) || value['pk'] === undefined) return false;
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    if (!('serial_number' in value) || value['serial_number'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('recorded_at' in value) || value['recorded_at'] === undefined) return false;
    if (!('recorded_by' in value) || value['recorded_by'] === undefined) return false;
    return true;
}

export function MacLookupOnAzureFromJSON(json: any): MacLookupOnAzure {
    return MacLookupOnAzureFromJSONTyped(json, false);
}

export function MacLookupOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): MacLookupOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pk': json['pk'],
        'mac_address': json['mac_address'],
        'serial_number': json['serial_number'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'object_type': json['object_type'],
        'source': CompassDeviceSourceFromJSON(json['source']),
        'source_ref': json['source_ref'] == null ? undefined : json['source_ref'],
        'recorded_at': json['recorded_at'],
        'recorded_by': json['recorded_by'],
    };
}

export function MacLookupOnAzureToJSON(json: any): MacLookupOnAzure {
    return MacLookupOnAzureToJSONTyped(json, false);
}

export function MacLookupOnAzureToJSONTyped(value?: MacLookupOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pk': value['pk'],
        'mac_address': value['mac_address'],
        'serial_number': value['serial_number'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
        'object_type': value['object_type'],
        'source': CompassDeviceSourceToJSON(value['source']),
        'source_ref': value['source_ref'],
        'recorded_at': value['recorded_at'],
        'recorded_by': value['recorded_by'],
    };
}

